export default "__VITE_ASSET__oTy6uF0p__"